<template>
  <div class="row justify-content-center align-items-md-center">
    <div class="col-md-6">
      <div class="card full-height bg-ligth">
        <div class="card-header">
          <h3 class="mb-0">{{ lista_campos != '' ? 'Editar' : 'Criar' }} Tipos de Classe</h3>
        </div>
        <div class="card-body">
          <div class="form">
          
            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-md-12">Nome:*</label>
                <input
                    required
                    type="text"
                    class="form-control"
                    v-model="form.nome"
                    placeholder="Digite o nome..."
                />
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-12 text-center">
                <button
                    @click="confirm(lista_campos == '' ? 'cria' : 'edita')"
                    class="btn btn-primary"
                    :disabled="verif"
                >
                  Salvar
                  <b-spinner
                      v-show="verif"
                      small
                      variant="dark"
                      type="grow"
                      label="Spinning"
                  ></b-spinner>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {fireAlert} from "@/core/mixins/alertMessageMixin";

export default {
  mixins: [fireAlert],
  data() {
    return {
      form: {
        nome: "",
      },
      verif: false,
    };
  },
  created() {
    this.preenxerCampos();
  },
  computed: {
    lista_setor() {
      return this.$store.state.configEmpresa.lista_setor;
    },
    lista_filials() {
      return this.$store.state.configEmpresa.lista_filials;
    },
    lista_local() {
      return this.$store.state.configEmpresa.lista_local;
    },
    lista_campos() {
      return this.$store.state.configEmpresa.lista_campos;
    },
    mensagem_alert() {
      return this.$store.state.tipoClasse.mensagem_alert;
    },
  },
  methods: {
    async confirm(tipo) {
      await this.$confirm({
        title: "Estas seguro?",
        message: `Esta ação  ` + tipo + ` uma Sala no sistema?`,
        button: {
          no: "No",
          yes: "Si",
        },
        callback: (confirm) => {
          if (confirm) {
            if (tipo == "cria") this.create();
            if (tipo == "edita") this.update();
          }
        },
      });
    },
    async create() {
      this.verif = true;
      await this.$store.dispatch("tipoClasse/create_tipo_classe", this.form);
      this.verif = false;
      this.fireAlert({
        ...this.mensagem_alert, routeName: 'tipoClasse'
      });
    },
    async update() {
      this.verif = true;
      await this.$store.dispatch("tipoClasse/update_tipo_classe", this.form);
      this.verif = false;
      this.fireAlert({
        ...this.mensagem_alert, routeName: 'tipoClasse'
      });
    },

    preenxerCampos() {
      if (this.lista_campos != "")
        this.form = {
          id: this.lista_campos.id,
          nome: this.lista_campos.nome,
          status: this.lista_campos.status,
          user_in: this.lista_campos.user_in,
          user_up: this.lista_campos.user_up,
          filial_id: this.lista_campos.filial_id,
      
        };
    },
  },
};
</script>

<style scoped>
.lista:hover {
  background-color: rgb(167, 183, 255);
}
</style>